const orderDetails = {
  'orderDetails.title': '订单详情',
  'orderDetails.tab.goodsList': '商品清单',
  'orderDetails.tab.payments': '付款信息',
  'orderDetails.tab.shipments': '发货信息',
  'orderDetails.tab.logistics': '物流信息',
  'orderDetails.tab.operationLog': '操作日志',

  'orderDetails.fetch.orderId.empty': '订单ID不能为空',

  'orderDetails.content.orderInfo.title': '订单信息',
  'orderDetails.export.productList': '导出商品清单',
  'orderDetails.export.exporting': '正在导出商品清单...',
  'orderDetails.export.success.message': '导出成功',
  'orderDetails.export.success.description': '商品清单已成功导出，请检查您的下载文件夹',
  'orderDetails.export.failed': '导出失败，请稍后重试',

  'orderDetails.content.customerInfo.title': '采购客户信息',
  'orderDetails.content.customerInfo.shopId': '门店id',
  'orderDetails.content.customerInfo.shopName': '门店名称',

  'orderDetails.content.shippingInfo.title': '收货信息',
  'orderDetails.content.shippingInfo.recipientName': '收货人',
  'orderDetails.content.shippingInfo.phone': '手机/座机',
  'orderDetails.content.shippingInfo.postalCode': '邮编',
  'orderDetails.content.shippingInfo.email': '邮箱',
  'orderDetails.content.shippingInfo.address': '收货地址',

  'orderDetails.content.amountInfo.title': '金额信息',
  'orderDetails.content.amountInfo.goodsAmount': '货款',
  'orderDetails.content.amountInfo.otherAmount': '其他费用',

  'orderDetails.feeType': '费用类型',
  'orderDetails.feeAmount': '金额',

  'orderDetails.productList.partsNum': '零件号',
  'orderDetails.productList.productTitle': '商品详情',
  'orderDetails.productList.replacePartsNum': '替换号',
  'orderDetails.productList.unitPrice': '单价',
  'orderDetails.productList.totalPrice': '总价',
  'orderDetails.productList.totalQuantity': '总数量',
  'orderDetails.productList.shippedQuantity': '已发货',

  'orderDetails.operationRecord.operationType': '操作类型',
  'orderDetails.operationRecord.operationUser': '操作人',
  'orderDetails.operationRecord.operationDate': '操作日期',

  'orderDetails.payments.paymentId': '付款单id',
  'orderDetails.payments.paymentMethod': '付款方式',
  'orderDetails.payments.paymentAmount': '付款金额',
  'orderDetails.payments.paymentDate': '付款日期',
  'orderDetails.payments.payer': '付款人',
  'orderDetails.payments.payerContact': '联系方式',
  'orderDetails.payments.description': '描述',

  'orderDetails.shipments.shipmentId': '发货单id',
  'orderDetails.shipments.shippingMethod': '发货方式',
  'orderDetails.shipments.shippingStatus': '发货状态',
  'orderDetails.shipments.shippingDate': '发货日期',
};

export default orderDetails;
